import { Tab, Tabs } from "@mui/material";
import React from "react";
import { Accordion } from "react-bootstrap";
import faqs from "../assets/data/faq.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const Faqs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <section className="section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-10 mx-auto faq-content">
            <h1 className="text-center">Frequantly Asked Questions</h1>
            <Tabs value={value} onChange={handleChange}>
              <Tab
                label="For Customers"
                id={`simple-tab-0`}
                aria-controls={`simple-tabpanel-0`}
              />
              <Tab
                label="For Vendors"
                id={`simple-tab-1`}
                aria-controls={`simple-tabpanel-1`}
              />
            </Tabs>
            <CustomTabPanel value={value} index={0} className="faq-item-wrap">
              {faqs["customer"].map((faq, index) => (
                <div key={index} className="faq-item">
                  <h3>
                    <span>{faq.section}</span>
                  </h3>
                  {faq.items.map((item, i) => (
                    <Accordion defaultActiveKey={0}>
                      <Accordion.Item eventKey={i}>
                        <Accordion.Header>
                          <span>{item.question}</span>
                          <FontAwesomeIcon icon={faChevronDown} />
                        </Accordion.Header>
                        <Accordion.Body>{item.answer}</Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ))}
                </div>
              ))}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              {faqs["vendor"].map((faq, index) => (
                <div key={index}>
                  <h3>
                    <span>{faq.section}</span>
                  </h3>
                  {faq.items.map((item, i) => (
                    <Accordion defaultActiveKey={0}>
                      <Accordion.Item eventKey={i}>
                        <Accordion.Header>{item.question}</Accordion.Header>
                        <Accordion.Body>{item.answer}</Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  ))}
                </div>
              ))}
            </CustomTabPanel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faqs;
